import {
    UPLOAD_FILE,
    GET_FILE,
    CLEAR_FILE,
} from "../actions/actionTypes";

const initialState = {
    upload_files: []
};

function UploadRedux(state = initialState, action) {
    switch (action.type) {
        case CLEAR_FILE:
            return {
                ...initialState
            }
        case GET_FILE:
            return {
                upload_files: action.payload
            }
        default:
            return state;
    }
}

export default UploadRedux;
